













































import { Component, Vue } from 'vue-property-decorator'
@Component({
  name: 'Navbar'
})
export default class Navbar extends Vue {

  toolbarTitle: string = '僕らのビジネスアイデア'
  isDrawer: boolean = false
  menuList: { label: string, to: string }[] = [
    {
      label: 'ログイン',
      to: 'Login',
    },
    {
      label: 'みんなのアイデア',
      to: 'Home',
    },
    {
      label: 'アイデア投稿',
      to: 'NewIdea',
    },
  ];

  onClickNavigationItem( menu: any ) {
    this.$router.push({ name: menu.to })
  }
  
}
